<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [modalHelpIndex]="modalHelpIndex" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [isPrimaryBtnEnabled]="!isBusy">
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="electronicID">Electronic ID:</label>
        </div>
        <div class="modal-row-column-max">
            <input type="text" [attr.data-automation-id]="modalAutomationId + '-electronic-ID-input'"
                name="electronicID" [(ngModel)]="electronicID">
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="dateOfShipment">Date of Shipment:</label>
        </div>
        <res-custom-date-time-picker class="date-time-picker" [isFormControl]="true" name="dateOfShipment"
            ngDefaultControl [inputPlaceholder]="defaultDatePlaceholder" [(ngModel)]="dateOfShipment"
            [attr.data-automation-id]="modalAutomationId + '-date-of-shipment-input'">
        </res-custom-date-time-picker>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="nameOfShipper">Name of Shipper:</label>
        </div>
        <div class="modal-row-column-max">
            <input type="text" [attr.data-automation-id]="modalAutomationId + '-name-of-shipper-input'"
                name="nameOfShipper" [(ngModel)]="nameOfShipper">
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="trackingNumber">Tracking Number:</label>
        </div>
        <div class="modal-row-column-max">
            <input type="text" [attr.data-automation-id]="modalAutomationId + '-tracking-number-input'"
                name="trackingNumber" [(ngModel)]="trackingNumber">
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="dateReceived">Date Received:</label>
        </div>
        <div class="modal-row-column-max">
            <res-custom-date-time-picker class="date-time-picker" [isFormControl]="true" name="dateReceived"
                ngDefaultControl [inputPlaceholder]="defaultDatePlaceholder" [(ngModel)]="dateReceived"
                [attr.data-automation-id]="modalAutomationId + '-date-of-received-input'">
            </res-custom-date-time-picker>
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="recipientName">Recipient Name:</label>
        </div>
        <div class="modal-row-column-max">
            <input type="text" [attr.data-automation-id]="modalAutomationId + '-recipient-name-input'"
                name="recipientName" [(ngModel)]="recipientName">
        </div>
    </div>


</res-base-modal>